import CryptoJS from "crypto-js";

export const cifrarAES = (llave, iv, texto) => {
  const derived_key = CryptoJS.enc.Base64.parse(llave);
  iv = CryptoJS.enc.Utf8.parse(iv);
  return CryptoJS.AES.encrypt(texto, derived_key, {
    iv: iv,
  }).toString();
};
export const decryptAES = (llave, iv, data) => {
  let dataSin64 = CryptoJS.enc.Base64.parse(data);
  dataSin64 = CryptoJS.enc.Base64.stringify(dataSin64);
  const derived_key = CryptoJS.enc.Base64.parse(llave);
  iv = CryptoJS.enc.Utf8.parse(iv);
  const encrypted = CryptoJS.AES.decrypt(dataSin64, derived_key, {
    iv: iv,
  }).toString(CryptoJS.enc.Utf8);
  return encrypted;
};


/*Cifra texto usando AES-CBC con WebCrypto API*/
export async function encryptAESCBC(aesKey, text, ivString) {
  try {
    const encoder = new TextEncoder();

    const iv = encoder.encode(ivString.substring(0, 16).padEnd(16, '0'));

    const ciphertext = await crypto.subtle.encrypt(
      {
        name: "AES-CBC",
        iv: iv,
      },
      aesKey,
      encoder.encode(text)
    );

    return btoa(String.fromCharCode(...new Uint8Array(ciphertext)));
  } catch (error) {
    console.error("Error cifrando con AES-CBC:", error);
    throw new Error("No se pudo cifrar el texto");
  }
}

/**Descifra texto cifrado con AES-CBC*/
export async function decryptAESCBC(aesKey, ciphertext, ivString) {
  try {
    const encoder = new TextEncoder();

    const iv = encoder.encode(ivString.substring(0, 16).padEnd(16, '0'));

    const ciphertextArray = Uint8Array.from(atob(ciphertext), (c) =>
      c.charCodeAt(0)
    );

    const decrypted = await crypto.subtle.decrypt(
      {
        name: "AES-CBC",
        iv: iv,
      },
      aesKey,
      ciphertextArray
    );

    const decoder = new TextDecoder();
    return decoder.decode(decrypted);
  } catch (error) {
    console.error("Error descifrando con AES-CBC:", error);
    throw new Error("No se pudo descifrar el texto");
  }
}


/*Genera un par de llaves ECDH (pública y privada) usando Web Crypto API*/
export async function generateECDHKeyPair() {
  try {
    const keyPair = await window.crypto.subtle.generateKey(
      {
        name: "ECDH",
        namedCurve: "P-256",
      },
      true,
      ["deriveKey", "deriveBits"]
    );
    return keyPair;
  } catch (error) {
    console.error("Error generando par de llaves ECDH:", error);
    throw new Error("No se pudo generar el par de llaves ECDH");
  }
}

/*Exporta una llave pública ECDH a formato base64*/
export async function exportPublicKey(publicKey) {
  try {
    const exported = await window.crypto.subtle.exportKey("raw", publicKey);
    const exportedAsArray = new Uint8Array(exported);
    const exportedAsString = String.fromCharCode(...exportedAsArray);
    return btoa(exportedAsString);
  } catch (error) {
    console.error("Error exportando llave pública:", error);
    throw new Error("No se pudo exportar la llave pública");
  }
}

/*Importa una llave pública ECDH desde base64*/
export async function importPublicKey(base64Key) {
  try {
    const binaryString = atob(base64Key);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return await window.crypto.subtle.importKey(
      "raw",
      bytes,
      {
        name: "ECDH",
        namedCurve: "P-256",
      },
      false, 
      []
    );
  } catch (error) {
    console.error("Error importando llave pública:", error);
    throw new Error("No se pudo importar la llave pública del servidor");
  }
}

/**Deriva una llave compartida AES-CBC usando ECDH + HKDF (compatible con Python)*/
export async function deriveSharedKey(privateKey, publicKey) {
  try {

    const sharedSecret = await window.crypto.subtle.deriveBits(
      {
        name: "ECDH",
        public: publicKey,
      },
      privateKey,
      256
    );

    const info = new TextEncoder().encode('aes-cbc-encryption-key');

    const baseKey = await window.crypto.subtle.importKey(
      "raw",
      sharedSecret,
      { name: "HKDF" },
      false,
      ["deriveKey"]
    );


    const sharedKey = await window.crypto.subtle.deriveKey(
      {
        name: "HKDF",
        hash: "SHA-256",
        salt: new Uint8Array(0),
        info: info,
      },
      baseKey,
      {
        name: "AES-CBC",
        length: 256,
      },
      false,  // NO extractable (más seguro)
      ["encrypt", "decrypt"]
    );

    return sharedKey;
  } catch (error) {
    console.error("Error derivando llave compartida:", error);
    throw new Error("No se pudo derivar la llave compartida");
  }
}
